import a from "react";

var e = function e() {
  return a.createElement("div", {
    className: "hg-primarynav__placeholder"
  });
};

export { e as NavPlaceholder };